import type { IconNode } from '../types';

/**
 * @name slot-disc
 * @description Lucide Lab SVG icon node.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJNNiAxM0g0YTIgMiAwIDAgMS0yLTJWN2EyIDIgMCAwIDEgMi0yaDE2YTIgMiAwIDAgMSAyIDJ2NGEyIDIgMCAwIDEtMiAyaC0yIiAvPgogIDxwYXRoIGQ9Ik02IDloMTIiIC8+CiAgPGNpcmNsZSBjeD0iMTIiIGN5PSIxNCIgcj0iLjUiIC8+CiAgPHBhdGggZD0iTTguNyA5YTYuMDcgNi4wNyAwIDEgMCA2LjYgMCIgLz4KPC9zdmc+Cg==) - https://lucide.dev/icons/slot-disc
 * @see https://lucide.dev/guide/packages/lucide - Documentation
 *
 * @returns {Array}
 *
 */
const slotDisc: IconNode = [
  [
    'path',
    {
      d: 'M6 13H4a2 2 0 0 1-2-2V7a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v4a2 2 0 0 1-2 2h-2',
      key: '1ax7uy',
    },
  ],
  ['path', { d: 'M6 9h12', key: 'oae0tv' }],
  ['circle', { cx: '12', cy: '14', r: '.5', key: '16ytcz' }],
  ['path', { d: 'M8.7 9a6.07 6.07 0 1 0 6.6 0', key: 's2l0yp' }],
];

export default slotDisc;
